/*
  Warenkorb-Wächter für den Charm-Konfigurator.
  Hält jede selbst gestaltete Kette und ihre Aufpreis-Zeile(n) zusammen:
  - Kette entfernt → Aufpreis entfernen
  - Menge der Kette geändert → Aufpreis-Menge anpassen
  - Aufpreis fehlt → wieder hinzufügen
  Erkennung: Kette trägt _sd_id und _sd_aufpreis ("Varianten-ID:Stück je Kette,…"),
  Aufpreis-Zeile trägt _sd_fuer = _sd_id der Kette.
*/
(() => {
  if (window.sdWarenkorbPruefen) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let laeuft = null;

  const holeWarenkorb = () => fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

  const sollMengen = (kette) => {
    const liste = {};
    String(kette.properties._sd_aufpreis || '')
      .split(',')
      .filter(Boolean)
      .forEach((eintrag) => {
        const [id, stueck] = eintrag.split(':').map(Number);
        if (id && stueck) liste[id] = stueck * kette.quantity;
      });
    return liste;
  };

  async function pruefen() {
    const warenkorb = await holeWarenkorb();
    const ketten = {};
    warenkorb.items.forEach((item) => {
      const id = item.properties && item.properties._sd_id;
      if (id) ketten[id] = item;
    });

    const updates = {};
    const fehlend = [];
    const gesehen = {};

    // Das interne Charm-Lager ist nicht einzeln kaufbar.
    warenkorb.items.forEach((item) => {
      if (item.handle === 'charm-lager') updates[item.key] = 0;
    });

    warenkorb.items.forEach((item) => {
      const fuer = item.properties && item.properties._sd_fuer;
      if (!fuer) return;
      const kette = ketten[fuer];
      const soll = kette ? sollMengen(kette)[item.variant_id] || 0 : 0;
      gesehen[`${fuer}:${item.variant_id}`] = true;
      if (item.quantity !== soll) updates[item.key] = soll;
    });

    Object.entries(ketten).forEach(([id, kette]) => {
      Object.entries(sollMengen(kette)).forEach(([variantId, menge]) => {
        if (gesehen[`${id}:${variantId}`]) return;
        fehlend.push({
          id: Number(variantId),
          quantity: menge,
          properties: { Für: `${kette.product_title} · ${kette.variant_title}`, _sd_fuer: id },
        });
      });
    });

    if (!Object.keys(updates).length && !fehlend.length) return false;

    if (Object.keys(updates).length) {
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
    }
    if (fehlend.length) {
      await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: fehlend }),
      });
    }
    return true;
  }

  async function aktualisiereAnzeige() {
    if (document.querySelector('cart-items')) {
      window.location.reload();
      return;
    }
    const antwort = await fetch(`${window.location.pathname}?sections=cart-icon-bubble`);
    const sections = await antwort.json();
    const ziel = document.getElementById('cart-icon-bubble');
    if (ziel && sections['cart-icon-bubble']) {
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const quelle = html.querySelector('.shopify-section');
      if (quelle) ziel.innerHTML = quelle.innerHTML;
    }
  }

  window.sdWarenkorbPruefen = () => {
    if (laeuft) return laeuft;
    laeuft = pruefen()
      .then((geaendert) => (geaendert ? aktualisiereAnzeige() : null))
      .catch((fehler) => console.warn('Warenkorb-Wächter', fehler))
      .finally(() => {
        laeuft = null;
      });
    return laeuft;
  };

  const start = () => {
    window.sdWarenkorbPruefen();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.sdWarenkorbPruefen());
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
